import { render, staticRenderFns } from "./CatalogsForm.vue?vue&type=template&id=6e301098&"
import script from "./CatalogsForm.vue?vue&type=script&lang=js&"
export * from "./CatalogsForm.vue?vue&type=script&lang=js&"
import style0 from "./CatalogsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports